import {Column} from "react-table";
import {TableCustomCell} from "../../../../component/table/components/TableCustomCell";
import {DanhSachPhieuInterface} from "../models/KeHoachModel"
import {TableCustomHeader} from "../../../../component/table/components/TableCustomHeader";
import {formatDateToDDMMYYYY} from "../../../../utils/FormatUtils";
import {TYPE_KE_HOACH} from "./constansKeHoach";

const getTypePlan = (type: number) => {
  switch (type) {
    case TYPE_KE_HOACH[0].type:
      return TYPE_KE_HOACH[0].name;
    case TYPE_KE_HOACH[1].type:
      return TYPE_KE_HOACH[1].name;
    case TYPE_KE_HOACH[2].type:
      return TYPE_KE_HOACH[2].name;
    default:
      return '';
  }
}
export const DanhSachPhieuColumns: ReadonlyArray<
  Column<DanhSachPhieuInterface>
> = [
  {
    Header: (props) => (
      <TableCustomHeader<DanhSachPhieuInterface>
        tableProps={props}
        title="STT"
        className="text-center text-light spaces w-60px"
      />
    ),
    id: "stt",
    Cell: ({...props}) => (
      <TableCustomCell
        className="text-center "
        data={String(props?.row?.index + 1)}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<DanhSachPhieuInterface>
        tableProps={props}
        title="TT"
        className="text-center text-light spaces w-60px"
      />
    ),
    id: "custom",
    Cell: ({...props}) => (
      <div className="text-center">
        <i className="bi bi-circle-fill" style={{color: props.data[props.row.index]?.color}}></i>
      </div>
    )
    ,
  },
  {
    Header: (props) => (
      <TableCustomHeader<DanhSachPhieuInterface>
        tableProps={props}
        title="Ngày tạo"
        className="text-center text-white align-middle bg-pri spaces w-140px"
      />
    ),
    id: "doCreation",
    Cell: ({...props}) => (
      <TableCustomCell
        className="text-center s-2"
        data={formatDateToDDMMYYYY(props.data[props.row.index]?.doCreation)}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<DanhSachPhieuInterface>
        tableProps={props}
        title="Mã phiếu"
        className="text-center text-white align-middle bg-pri spaces w-140px"
      />
    ),
    id: "code",
    Cell: ({...props}) => (
      <TableCustomCell
        className="text-center s-2"
        data={props.data[props.row.index]?.code}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<DanhSachPhieuInterface>
        tableProps={props}
        title="Tên kế hoạch"
        className="text-center text-white align-middle bg-pri"
      />
    ),
    id: "planName",
    Cell: ({...props}) => (
      <TableCustomCell
        className="text-left s-2"
        data={props.data[props.row.index]?.planName}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<DanhSachPhieuInterface>
        tableProps={props}
        title="Loại kế hoạch"
        className="text-center text-white align-middle bg-pri"
      />
    ),
    id: "type",
    Cell: ({...props}) => (
      <TableCustomCell
        className="text-left s-2"
        data={getTypePlan(props.data[props.row.index]?.type)}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<DanhSachPhieuInterface>
        tableProps={props}
        title="Ngày bắt đầu"
        className="text-center text-white align-middle bg-pri spaces w-140px"
      />
    ),
    id: "startDate",
    Cell: ({...props}) => (
      <TableCustomCell
        className="text-center s-2"
        data={formatDateToDDMMYYYY(props.data[props.row.index]?.startDate)}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<DanhSachPhieuInterface>
        tableProps={props}
        title="Ngày kết thúc"
        className="text-center text-white align-middle bg-pri spaces w-140px"
      />
    ),
    id: "endDate",
    Cell: ({...props}) => (
      <TableCustomCell
        className="text-center s-2"
        data={formatDateToDDMMYYYY(props.data[props.row.index]?.endDate)}
      />
    ),
  },
];